export type SetApplicationStatusAction =
  | "agree-proposal"
  | "send-signing"
  | "client-signing"
  | "refusal";

type SetApplicationStatusResponseMessage = {
  success: string;
  error: string;
};

export const setApplicationBankStatusResponseMessage: Record<
  SetApplicationStatusAction,
  SetApplicationStatusResponseMessage
> = {
  "agree-proposal": {
    success: "Предложение согласовано",
    error: "Не удалось согласовать предложение",
  },
  "send-signing": {
    success: "Заявка успешно отправлена на подписание",
    error: "Не удалось отправить на подписание",
  },
  "client-signing": {
    success: "Документы успешно подписаны",
    error: "Не удалось подписать",
  },

  refusal: {
    success: "Успешно отказано",
    error: "Не удалось отказать",
  },
};
